export default __webpack_public_path__ + "static/media/box.e09a56cd.svg";